module.exports = __webpack_public_path__ + "img/Working_At_Desk_W_Computer.62b7862.png";